import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FilterIcon } from "../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { setReducerState } from "../../redux/crudSlice";
import { useAppSelector } from "../../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
var CatalougeHeaderComponent = function (props) {
    var _options$1$id, _options$;
    var pagingAPI = props.pagingAPI, options = props.options, onFilterClick = props.onFilterClick, pagingRequest = props.pagingRequest, setViewTypeValue = props.setViewTypeValue;
    var _a = useState(options[1].id), viewType = _a[0], setViewType = _a[1];
    var _b = useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var dispatch = useDispatch();
    useEffect(function () {
        var _getLocalStorageItem;
        var request = _objectSpread(_objectSpread({}, pagingRequest), {}, {
            // Status: filterValue?.data?.Status?.map((item: ResponseObject) => item?.Name),
            IdentityId: viewType === 1 ? (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId : undefined,
            search: searchValue !== null && searchValue !== void 0 ? searchValue : '',
            take: 10,
            skip: 0
        });
        if (viewType)
            setLocalStorageItem(LOCAL_STORAGE_KEYS.PAGING_VIEW_TYPE, viewType);
        pagingAPI({
            request: request
        });
    }, [viewType, filterValue, searchValue]);
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'catalogueHeader',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            p: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: true,
                    alignItems: "center",
                    justifyContent: 'start',
                    item: false,
                    columnSpacing: 2,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'selectType',
                            label: '',
                            value: (_options$1$id = (_options$ = options[1]) === null || _options$ === void 0 ? void 0 : _options$.id) !== null && _options$1$id !== void 0 ? _options$1$id : null,
                            select: true,
                            columnSize: 0,
                            children: options === null || options === void 0 ? void 0 : options.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
                                key: index,
                                value: item.id
                            }, item.name); }),
                            onChange: function (e, value) {
                                setViewType(value);
                                setViewTypeValue && setViewTypeValue(function () { return value; });
                                dispatch(setReducerState({
                                    key: 'filterValue',
                                    value: null
                                }));
                            }
                        },
                        // {
                        //     type: FormItemTypes.TextInput,
                        //     name: 'search',
                        //     label: '',
                        //     value: !isNullOrEmpty(searchValue) ? searchValue : null,
                        //     placeholder: "Search...",
                        //     columnSize: 3,
                        //     onChange: (e: any) => {
                        //         setSearchValue(e?.target?.value)
                        //     },
                        //     InputProps: {
                        //         startAdornment:
                        //             <img src={SearchIcon} alt="" style={{ width: '18px', height: '18px', marginRight: '8px' }} />
                        //         ,
                        //     }
                        // },
                        {
                            type: FormItemTypes.ContainerItem,
                            name: 'container2',
                            label: '',
                            value: null,
                            columnSize: true,
                            alignItems: "end",
                            justifyContent: 'start',
                            item: false,
                            columnSpacing: 2,
                            pt: 2,
                            pl: 2,
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: 'filters',
                                    columnSize: 0,
                                    label: '',
                                    value: null,
                                    startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                                    onClick: onFilterClick,
                                    children: 'Filters',
                                    variant: 'outlined',
                                    color: 'secondary',
                                    sx: {
                                        background: 'none'
                                    }
                                }]
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0
    });
};
export default CatalougeHeaderComponent;
